module.exports = __webpack_public_path__ + "media/images/dashboardImage1-a7d886d6.jpg";